<p class="mat-body-medium">
  <ng-content></ng-content>
</p>
